import axios from 'axios'
import * as t from 'io-ts'

import { GrantPeriod } from '@espoon-voltti/nuora-domain/grants'

import { grantsApiUrl, extractResponseData } from './utils'

class GrantPeriodApi {
  public get = (): Promise<GrantPeriod[]> =>
    axios
      .get(`${grantsApiUrl}/grant-periods`)
      .then(extractResponseData)
      .then((r) => t.array(GrantPeriod).decodeOrThrow(r))
}

export const grantPeriodApi = new GrantPeriodApi()
